import { RefinementCtx } from 'zod';
import { TXCenter } from '@/api/apis/facilities';
import { OpoOrganization } from '@/api/apis/opo';
import { Employee } from '@/api/apis/resources';
import { SelectItemType, NameByValue } from '@/types';
import { getFullName, addCustomZodErrors, COUNTRY_SCHEMA } from '@/utils/helpers';
import { getCountryHasStates } from '@/hooks/useCountrySubdivisionInfo';

export const createLocationFormValidation =
  (composedSubdivisionsList: Record<string, NameByValue[]>) =>
  ({ country, state }: { country: string; state: string | null | undefined }, ctx: RefinementCtx) => {
    const countryHasStates = getCountryHasStates(composedSubdivisionsList, country);
    const countrySchemaResult = COUNTRY_SCHEMA.safeParse(country);

    if (!countrySchemaResult.success) {
      addCustomZodErrors({ ctx, path: ['country'], message: countrySchemaResult.error.issues[0].message });
    }

    if (countryHasStates && !state) {
      addCustomZodErrors({ ctx, path: ['state'], message: 'Select state' });
    }
  };

export const employeeMapper = (employee: Employee): SelectItemType => ({
  value: employee.id,
  name: getFullName(employee.firstName, employee.lastName),
});

export const txCenterMapper = (item: TXCenter): SelectItemType & { data: TXCenter } => ({
  name: item.name,
  value: item.id,
  data: item,
});

export const opoOrgMapper = (item: OpoOrganization): SelectItemType & { data: OpoOrganization } => ({
  name: item.name,
  value: item.id,
  data: item,
});
